import { render } from "./Tem014.vue?vue&type=template&id=f28932ec"
import script from "./Tem014.vue?vue&type=script&lang=js"
export * from "./Tem014.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__